import React from "react";
import AntdCarousel, {CarouselProps} from 'antd/lib/carousel';
import {withError} from '@fishx/tracker';

interface CProps extends CarouselProps {
  forwardedRef?: any;
};
export const Carousel: React.FC<CProps> = (props) => {
   const { forwardedRef, ...rest } = props;
   return (
     <AntdCarousel ref={forwardedRef} {...rest} />
   )
};
export default withError(withError, {forwardRef: true});




// WEBPACK FOOTER //
// ./src/components/carousel/index.tsx